export default "__VITE_ASSET__gH6SZ2me__"